import {Component, OnInit, Input, Output, EventEmitter, Inject, ChangeDetectorRef} from '@angular/core';
import { MonitoredTrain } from '../../models/monitored-train';
import {CookieService} from "ngx-cookie-service";

@Component({
  selector: 'app-monitored-train-info',
  template: require('./monitored-train-info.component.html'),
  styles: [require('./monitored-train-info.component.sass')]
})
export class MonitoredTrainInfoComponent implements OnInit {

  @Input() train: MonitoredTrain;

  @Output() investigateTrain = new EventEmitter<MonitoredTrain>();
  speedMetric: string | undefined;

  constructor(  private cookieService: CookieService,
                @Inject('$rootScope') $rootScope: any,
                private cd: ChangeDetectorRef) {
    $rootScope.$on('unitsChanged', (ev, value) => {
      this.speedMetric = value;
      this.cd.detectChanges();
    });
  }

  ngOnInit(): void {
  }

  onInvestigateTrain = () => {
    this.investigateTrain.emit(this.train);
  };
}
